import styled from "styled-components"

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  column-gap: 8px;
  row-gap: 8px;
`
